import { AxiosResponse } from "axios";
import advService from "../../util/advService";
import { DECLERATION_GET, DECLERATION_POST } from "../../util/newconfig";
import { JavaResponse } from "../../types";

export type Delaration = {
    declarationDate: string;
    goodsValue: number;
    remark: string;
    receiverName: string;
    receiverAddress: string;
    consignmentDetails: string;
    senderName: string;
    invoiceNumber: string;
    invoiceDate: string;
    transportationMode: string;
    transportationNumber: string;
    active: boolean;
}

export const DeclarationsService = {
    getDeclaration : async (id: string, pid: string, uuid:string): Promise<Delaration> =>  {
        return new Promise((resolve, reject) => {
            let config = {...DECLERATION_GET}
            config.url = config.url.replace("{id}", id).replace("{pid}", pid).replace("{uuid}", uuid);
            advService(
                config,
                {},
                (response: AxiosResponse<JavaResponse<Delaration>>) => {
                    if (response.status === 200) {
                        resolve(response.data.response);
                    } else {
                        reject(new Error("Failed to fetch declaration"));
                    }
                },
            );
        });
    },

    createDeclarations : async ( pid: string, uuid:string, data: Delaration[]) : Promise<
        JavaResponse<Delaration>
    > => {
        return new Promise((resolve, reject) => {
            let config = {...DECLERATION_POST}
            config.url = config.url.replace("{pid}", pid).replace("{uuid}", uuid);
            advService(
                config,
                data,
                (response: AxiosResponse<JavaResponse<Delaration>>) => {
                    if (response.status === 200) {
                        resolve(response.data);
                    } else {
                        reject(new Error("Failed to create declaration"));
                    }
                },
            );
        });
    },

    updateDeclarations: async ( pid: string, uuid:string, data: (Delaration & {id: string})[]) => {
        return new Promise((resolve, reject) => {
            let config = {...DECLERATION_POST}
            config.url = config.url.replace("{pid}", pid).replace("{uuid}", uuid);
            advService(
                config,
                data,
                (response: AxiosResponse<JavaResponse<Delaration>>) => {
                    if (response.status === 200) {
                        resolve(response.data);
                    } else {
                        reject(new Error("Failed to update declaration"));
                    }
                },
            );
        });
    }
}